export default __webpack_public_path__ + "static/media/background_skin.4e78456c.svg";